"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var store = require("store");
var expire = require("store/plugins/expire");
store.addPlugin(expire);
var symbols = '0123456789acbdefghijklmnopqrstuvwxyzABCDEFGHIJKLMOPQRSTUVWXYZ';
var keys = {
    visitKey: '_findify_visit',
    uniqKey: '_findify_uniq',
    ctKey: '_findify_ct',
    cartKey: '_findify_cart',
};
function generateId() {
    if (global.document && !!~global.document.cookie.indexOf('findify_optout=1'))
        return '0';
    var str = '';
    for (var i = 0; i < 16; i++) {
        str += symbols[(Math.random() * symbols.length) | 0];
    }
    return str;
}
var uniqKey = keys.uniqKey, visitKey = keys.visitKey, cartKey = keys.cartKey, ctKey = keys.ctKey;
function read(name) {
    return store.get(name);
}
function write(name, value, permanent) {
    var ttl = permanent ? 1000 * 3600 * 24 * 365 * 30 : 1000 * 60 * 30;
    if (!value)
        return store.remove(name);
    return store.set(name, value, new Date().getTime() + ttl);
}
function createUid() {
    var id = generateId();
    write(uniqKey, id, true);
    return id;
}
function createSid() {
    var id = generateId();
    write(visitKey, generateId());
    return id;
}
var persist = !!(read(uniqKey) && read(visitKey));
exports.default = {
    get uid() {
        if (global.document && !!~global.document.cookie.indexOf('findify_optout=1'))
            return '0';
        return read(uniqKey) || createUid();
    },
    get sid() {
        if (global.document && !!~global.document.cookie.indexOf('findify_optout=1'))
            return '0';
        return read(visitKey) || createSid();
    },
    get cart() {
        return read(cartKey);
    },
    set cart(data) {
        write(cartKey, data);
    },
    get exist() {
        return !!(read(uniqKey) && read(visitKey));
    },
    persist: persist,
    memoize: function (type, request) {
        var data = read(ctKey);
        write(ctKey, __assign({}, data, (_a = {}, _a[type] = request, _a)));
        var _a;
    },
    get memorized() {
        var data = read(ctKey);
        if (!data) {
            return {};
        }
        write(ctKey);
        return data;
    },
};
//# sourceMappingURL=storage.js.map